
const downloadIcon = props => (
    <svg height="512pt" viewBox="-23 0 512 512" width="512pt" {...props}>
        <path
            d="M337.953 230.602c66.16 9.285 117.063 66.054 117.063 134.777 0 75.125-60.934 136.058-136.059 136.058-51.644 0-96.68-28.812-119.621-71.285-10.457-19.312-16.434-41.402-16.434-64.879 0-75.125 60.934-136.058 136.055-136.058 6.406.105 12.703.535 18.996 1.387zm0 0"
            fill="#fedb41"
        />
        <path
            d="M337.953 230.602a139.95 139.95 0 0 0-18.996-1.282c-75.121 0-136.055 60.934-136.055 136.059 0 23.476 5.977 45.566 16.434 64.879l-.215.11H57.2c-25.933 0-46.957-21.024-46.957-46.954V57.73c0-25.93 21.024-46.953 46.957-46.953h172.23v77.688c0 20.058 16.22 36.281 36.282 36.281h72.242zm0 0"
            fill="#00acea"
        />
        <path
            d="M229.43 10.777l108.523 113.97h-72.242c-20.063 0-36.281-16.224-36.281-36.282zm0 0"
            fill="#00efd1"
        />
        <path
            d="M348.945 221.64v-96.894c0-2.777-1.28-5.336-3.093-7.363L237.219 3.309C235.19 1.176 232.309 0 229.429 0H57.2C25.4 0 0 25.93 0 57.73v325.684c0 31.8 25.398 57.305 57.2 57.305h135.948C219.61 485.535 267.203 512 318.961 512c80.887 0 146.726-65.734 146.726-146.727 0-35.64-12.699-69.898-36.175-96.68-21.235-24.116-49.621-40.55-80.567-46.952zM240.102 37.458l72.882 76.723h-47.273c-14.086 0-25.613-11.63-25.613-25.715V37.457zM21.344 383.414V57.73c0-20.062 15.898-36.386 35.855-36.386h161.559v67.12c0 25.93 21.023 47.06 46.953 47.06h61.894v83.34c-3.203-.106-5.765-.532-8.539-.532-37.242 0-71.496 14.297-97.32 36.707H86.223c-5.868 0-10.672 4.8-10.672 10.672 0 5.871 4.8 10.672 10.672 10.672h115.675c-7.578 10.672-13.875 21.344-18.78 33.082H86.222c-5.868 0-10.672 4.8-10.672 10.668 0 5.87 4.8 10.672 10.672 10.672h89.957c-2.668 10.672-4.055 22.515-4.055 34.363 0 18.672 3.52 37.133 10.352 54.207H57.199c-19.957 0-35.855-16.008-35.855-35.96zM318.96 490.766c-45.992 0-88.36-25.184-110.34-65.63-9.926-18.245-15.152-38.843-15.152-59.757 0-69.149 56.234-125.387 125.383-125.387 5.87 0 11.738.43 17.5 1.176 29.668 4.16 56.984 18.887 76.832 41.512 20.062 22.836 31.054 52.18 31.054 82.699.106 69.148-56.129 125.387-125.277 125.387zm0 0"
            fill="#083863"
        />
        <path
            d="M86.223 223.027H194.32c5.871 0 10.672-4.804 10.672-10.672 0-5.87-4.8-10.671-10.672-10.671H86.223c-5.868 0-10.672 4.8-10.672 10.671 0 5.868 4.804 10.672 10.672 10.672zm0 0M373.594 363.137l-43.856 47.273V293.883c0-5.871-4.804-10.672-10.672-10.672-5.87 0-10.671 4.8-10.671 10.672V410.41l-44.18-47.273c-4.055-4.266-10.883-4.586-15.152-.535-4.27 4.058-4.59 10.78-.536 15.046l62.426 67.122c2.027 2.136 4.805 3.418 7.79 3.418 2.987 0 5.765-1.282 7.788-3.418l62.426-67.122c4.059-4.265 3.844-11.097-.426-15.046-4.265-4.051-10.883-3.73-14.937.535zm0 0"
            fill="#083863"
        />
    </svg>
);

const catIcon = props => (
    <svg viewBox="0 0 512 512" {...props}>
        <g fill="#004a7b">
            <path d="M75 512c-8.291 0-15-6.709-15-15v-61c0-8.291 6.709-15 15-15s15 6.709 15 15v61c0 8.291-6.709 15-15 15zM271 436v61c0 8.399-6.599 15-15 15s-15-6.601-15-15v-61c0-8.401 6.599-15 15-15s15 6.599 15 15z" />
        </g>
        <g fill="#00345b">
            <path d="M437 512c-8.291 0-15-6.709-15-15v-61c0-8.291 6.709-15 15-15s15 6.709 15 15v61c0 8.291-6.709 15-15 15zM271 436v61c0 8.399-6.599 15-15 15v-91c8.401 0 15 6.599 15 15z" />
        </g>
        <path
            d="M271 226v120c0 8.399-6.599 15-15 15s-15-6.601-15-15V226c0-8.401 6.599-15 15-15s15 6.599 15 15z"
            fill="#004a7b"
        />
        <path
            d="M271 226v120c0 8.399-6.599 15-15 15V211c8.401 0 15 6.599 15 15z"
            fill="#00345b"
        />
        <path
            d="M452 316v30c0 8.399-6.599 15-15 15s-15-6.601-15-15v-30c0-8.401-6.599-15-15-15H105c-8.401 0-15 6.599-15 15v30c0 8.399-6.599 15-15 15s-15-6.601-15-15v-30c0-24.901 20.099-45 45-45h302c24.901 0 45 20.099 45 45z"
            fill="#004a7b"
        />
        <path
            d="M452 316v30c0 8.399-6.599 15-15 15s-15-6.601-15-15v-30c0-8.401-6.599-15-15-15H256v-30h151c24.901 0 45 20.099 45 45z"
            fill="#00345b"
        />
        <g fill="#17ace8">
            <path d="M105 451H45c-24.814 0-45-20.186-45-45v-30c0-24.814 20.186-45 45-45h60c24.814 0 45 20.186 45 45v30c0 24.814-20.186 45-45 45zM286 331h-60c-24.901 0-45 20.099-45 45v30c0 24.899 20.099 45 45 45h60c24.901 0 45-20.101 45-45v-30c0-24.901-20.099-45-45-45z" />
        </g>
        <g fill="#1689fc">
            <path d="M467 451h-60c-24.814 0-45-20.186-45-45v-30c0-24.814 20.186-45 45-45h60c24.814 0 45 20.186 45 45v30c0 24.814-20.186 45-45 45zM105 512H45c-8.291 0-15-6.709-15-15s6.709-15 15-15h60c8.291 0 15 6.709 15 15s-6.709 15-15 15zM301 497c0 8.399-6.599 15-15 15h-60c-8.401 0-15-6.601-15-15 0-8.401 6.599-15 15-15h60c8.401 0 15 6.599 15 15z" />
        </g>
        <g fill="#136ef1">
            <path d="M467 512h-60c-8.291 0-15-6.709-15-15s6.709-15 15-15h60c8.291 0 15 6.709 15 15s-6.709 15-15 15zM301 497c0 8.399-6.599 15-15 15h-30v-30h30c8.401 0 15 6.599 15 15z" />
        </g>
        <path
            d="M331 376v30c0 24.899-20.099 45-45 45h-30V331h30c24.901 0 45 20.099 45 45z"
            fill="#1689fc"
        />
        <path
            d="M286 151h-60c-8.401 0-15 6.599-15 15v60c0 8.399 6.599 15 15 15h60c8.401 0 15-6.601 15-15v-60c0-8.401-6.599-15-15-15z"
            fill="#a8aff1"
        />
        <path
            d="M301 166v60c0 8.399-6.599 15-15 15h-30v-90h30c8.401 0 15 6.599 15 15z"
            fill="#8a93e6"
        />
        <path
            d="M346 0H166c-24.901 0-45 20.099-45 45v91c0 24.899 20.099 45 45 45h180c24.901 0 45-20.101 45-45V45c0-24.901-20.099-45-45-45z"
            fill="#e1e4fb"
        />
        <path
            d="M391 45v91c0 24.899-20.099 45-45 45h-90V0h90c24.901 0 45 20.099 45 45z"
            fill="#c5c9f7"
        />
        <path
            d="M331 226c0 8.399-6.599 15-15 15H196c-8.401 0-15-6.601-15-15 0-8.401 6.599-15 15-15h120c8.401 0 15 6.599 15 15z"
            fill="#e1e4fb"
        />
        <path
            d="M316 241h-60v-30h60c8.401 0 15 6.599 15 15 0 8.399-6.599 15-15 15z"
            fill="#c5c9f7"
        />
        <path
            d="M346 30H166c-8.401 0-15 6.599-15 15v91c0 8.399 6.599 15 15 15h180c8.401 0 15-6.601 15-15V45c0-8.401-6.599-15-15-15z"
            fill="#004a7b"
        />
        <path
            d="M346 151h-90V30h90c8.401 0 15 6.599 15 15v91c0 8.399-6.599 15-15 15z"
            fill="#00345b"
        />
    </svg>
);

const panelIcon = props => (
    <svg viewBox="0 0 512 512" {...props}>
        <path
            fill="#ebebeb"
            d="M400.394 100.964l.011 229.053L0 330.016V100.964l201.859-16.699z"
        />
        <path fill="#a6e2e3" d="M0 61.28h400.39v39.684H0z" />
        <path
            fill="#ccc"
            d="M75.275 202.48v127.537h325.13l-.006-127.537h-36.324z"
        />
        <path
            fill="#ebebeb"
            d="M512 221.668V450.72H111.594V221.668l200.203-18.072z"
        />
        <path fill="#ffa638" d="M512 181.983v39.685H111.594v-39.685h288.8z" />
    </svg>
);

const btnIcon = props => (
    <svg viewBox="0 0 512 512" {...props}>
        <defs>
            <linearGradient id="a" x1="10%" y1="0%" x2="90%" y2="100%">
                <stop offset="0%" stopColor="#FE7B39" />
                <stop offset="100%" stopColor="#FD3838" />
            </linearGradient>
        </defs>
        <rect width={512} height={200} rx={8} ry={8} fill="url(#a)" />
    </svg>
);

const btnC2A = props => (
    <svg viewBox="0 0 512 512" {...props}>
        <path
            d="M497.807 232.355l-29.945 5.99v-88.276l29.945 5.99A17.653 17.653 0 0 1 512 173.37v41.673c0 8.416-5.94 15.663-14.193 17.312z"
            fill="#d7deed"
        />
        <path
            d="M497.807 205.873l-29.945 5.99v26.483l29.945-5.99A17.655 17.655 0 0 0 512 215.044v-26.483c0 8.416-5.94 15.661-14.193 17.312z"
            fill="#c7cfe2"
        />
        <path
            d="M26.483 256h-8.828C7.904 256 0 248.096 0 238.345v-88.276c0-9.751 7.904-17.655 17.655-17.655h8.828V256z"
            fill="#be4b50"
        />
        <path
            d="M229.517 97.103V291.31c61.793 0 158.897 26.483 229.517 88.276V8.828c-70.62 61.793-167.724 88.275-229.517 88.275z"
            fill="#d7deed"
        />
        <path
            d="M476.69 388.414h-8.828a8.829 8.829 0 0 1-8.828-8.828V8.828A8.829 8.829 0 0 1 467.862 0h8.828a8.829 8.829 0 0 1 8.828 8.828v370.759a8.83 8.83 0 0 1-8.828 8.827z"
            fill="#959cb3"
        />
        <path
            d="M242.05 494.345a8.83 8.83 0 0 1-8.657-7.096L194.207 291.31H97.103l39.88 199.401C139.459 503.09 150.328 512 162.952 512h79.098a8.829 8.829 0 0 0 0-17.655z"
            fill="#d2555a"
        />
        <path
            d="M211.862 291.31v10.177a8.825 8.825 0 0 1-7.377 8.707l-141.241 23.54c-5.38.897-10.279-3.252-10.279-8.707V291.31h158.897z"
            fill="#be4b50"
        />
        <path
            d="M229.517 291.31H52.966c-19.501 0-35.31-15.809-35.31-35.31V132.414c0-19.501 15.809-35.31 35.31-35.31h176.552V291.31z"
            fill="#ff6464"
        />
        <path fill="#959cb3" d="M211.862 97.103h17.655V291.31h-17.655z" />
        <path
            d="M17.655 229.517h194.207v61.793H52.966c-19.501 0-35.31-15.809-35.31-35.31v-26.483z"
            fill="#d2555a"
        />
        <path fill="#707487" d="M211.862 229.517h17.655v61.793h-17.655z" />
        <path
            d="M229.517 291.31c61.793 0 158.897 26.483 229.517 88.276V273.655c-70.621-29.426-167.724-44.138-229.517-44.138v61.793z"
            fill="#c7cfe2"
        />
        <path
            d="M476.69 282.483h-8.828a8.829 8.829 0 0 1-8.828-8.828v105.931a8.829 8.829 0 0 0 8.828 8.828h8.828a8.829 8.829 0 0 0 8.828-8.828V273.655a8.83 8.83 0 0 1-8.828 8.828z"
            fill="#707487"
        />
    </svg>
);

const theCat = props => (
    <svg viewBox="0 0 117 117" {...props}>
        <title />
        <g fillRule="nonzero" fill="none">
            <path
                d="M4.5 52.9h44.3c2.3 0 4.1-1.8 4.1-4.1V4.5c0-2.3-1.8-4.1-4.1-4.1H4.5C2.2.4.4 2.2.4 4.5v44.3c0 2.2 1.9 4.1 4.1 4.1zM8.6 8.6h36.1v36.1H8.6V8.6z"
                fill="#4A4A4A"
            />
            <path
                d="M116.6 4.5c0-2.3-1.8-4.1-4.1-4.1H68.2c-2.3 0-4.1 1.8-4.1 4.1v44.3c0 2.3 1.8 4.1 4.1 4.1h44.3c2.3 0 4.1-1.8 4.1-4.1V4.5zm-8.2 40.2H72.3V8.6h36.1v36.1zM4.5 116.6h44.3c2.3 0 4.1-1.8 4.1-4.1V68.2c0-2.3-1.8-4.1-4.1-4.1H4.5c-2.3 0-4.1 1.8-4.1 4.1v44.3c0 2.2 1.9 4.1 4.1 4.1zm4.1-44.3h36.1v36.1H8.6V72.3z"
                fill="#17AB13"
            />
            <path
                d="M112.5 64.1H68.2c-2.3 0-4.1 1.8-4.1 4.1v44.3c0 2.3 1.8 4.1 4.1 4.1h44.3c2.3 0 4.1-1.8 4.1-4.1V68.2c0-2.2-1.9-4.1-4.1-4.1zm-4.1 44.3H72.3V72.3h36.1v36.1z"
                fill="#4A4A4A"
            />
        </g>
    </svg>
);

const packages = props => (
    <svg viewBox="0 0 512 512" {...props} width="1em" height="1em">
        <g fill="#7941b6">
            <path d="M244.872 109.344h194.896V132.8H244.872zM244.872 174.336H512V196.6H244.872z" />
        </g>
        <path fill="#7941b6" d="M0 74.16h178.088v155.824H0z" />
        <g fill="#17ab13">
            <path d="M244.872 315.456h184.96v22.264h-184.96zM244.872 382.224H512v22.264H244.872z" />
        </g>
        <path fill="#17ab13" d="M0 282.016h178.088V437.84H0z" />
        <g fill="#fff">
            <path d="M55.536 318.536l71.752 41.424-71.752 41.424zM55.536 110.648l71.752 41.424-71.752 41.424z" />
        </g>
    </svg>
);

const slider = props => (
    <svg viewBox="0 0 1000 1000" {...props} width="1em" height="1em">
        <g xmlns="http://www.w3.org/2000/svg">
            <path
                d="M10 304.77v291.89h980V12.88H10v291.89zm947.46-181.84v81.35H42.54V41.58h914.92v81.35zM181.69 340.56c3.25 2.87 4.4 6.32 4.4 11.87 0 7.27-1.34 8.8-28.71 36.37l-28.52 28.9 28.52 28.9c26.61 26.8 28.71 29.29 28.71 35.98 0 9.19-6.89 16.46-15.7 16.46-5.55 0-10.14-4.02-42.11-35.98L92.3 427.07v-8.61c0-11.68 4.02-16.84 40.77-53.02 27.75-27.18 30.05-29.09 36.94-29.09 4.79 0 8.62 1.34 11.68 4.21zm686.19 29.67c22.4 22.39 34.64 35.98 36.17 40.2 4.02 12.44 1.34 16.65-32.54 50.91-40 40.58-44.6 43.26-55.89 32.16-10.15-10.34-8.81-13.02 23.16-45.17 15.9-15.9 28.72-29.68 28.72-30.63s-12.82-14.74-28.71-30.63c-30.05-30.43-31.39-32.35-25.84-43.07 3.25-6.32 5.17-7.27 14.17-7.46 6.12-.19 9.37 2.68 40.76 33.69z"
                fill="#7e1ddf"
            />
            <path
                d="M103.6 61.3c-16.08 6.13-30.05 18.38-38.47 34.26-3.64 6.89-4.4 11.1-4.4 27.37 0 16.46.57 20.48 4.59 28.71 6.32 12.82 19.14 25.07 32.35 31.2 15.89 7.27 36.94 7.27 53.02-.19 14.93-6.89 26.22-18.18 32.92-32.73 7.46-16.27 7.46-37.32.19-53.21-6.12-13.21-18.37-26.03-31.2-32.16-11.49-5.74-37.71-7.46-49-3.25zm36.94 34.26c24.69 13.97 20.29 49.96-7.08 58.95-20.29 6.7-41.15-9.57-41.15-31.97-.01-24.3 26.41-39.23 48.23-26.98z"
                fill="red"
            />
            <path
                d="M253.09 60.53c-16.46 5.36-35.6 21.82-41.34 35.79-10.91 26.03-4.59 56.85 15.12 74.84 12.82 11.48 26.61 16.65 44.41 16.65 12.44 0 17.23-.77 26.03-4.98 42.11-19.52 52.45-72.73 20.29-104.89-12.82-12.82-24.31-17.8-43.45-18.38-9.01-.37-18.38.01-21.06.97zm32.34 33.69c24.12 12.44 23.73 47.47-.57 58.57-10.34 4.59-17.23 4.59-27.56-.38-11.29-5.55-17.8-15.69-17.99-28.14 0-13.4 6.32-23.93 18.57-30.63 5.54-3.06 21.24-2.87 27.55.58z"
                fill="#15cd14"
            />
            <path
                d="M396.64 61.87c-17.99 6.51-30.62 18.38-38.85 36.75-3.06 6.7-4.02 12.82-4.02 24.31 0 18.18 5.36 31.97 17.8 45.55 17.8 19.14 49.38 25.46 73.31 14.36 13.21-6.12 26.03-18.37 32.35-31.2 4.02-8.23 4.59-12.25 4.59-28.71 0-17.04-.57-20.29-5.17-28.71-5.74-11.29-18.57-23.73-30.63-29.86-10.91-5.74-36.75-7.08-49.38-2.49zm38.47 33.88c9.95 6.7 15.12 15.7 15.12 26.61 0 23.93-21.44 39.62-43.07 31.2-25.46-9.57-28.9-43.64-5.74-57.61 10.34-6.13 24.7-6.32 33.69-.2z"
                fill="#0f56f4"
            />
            <path
                d="M10 808.16v178.96h980V629.2H10v178.96zm233.32-122.88c44.21 15.5 73.69 54.93 76.37 101.83 2.3 45.55-22.78 88.62-63.16 107.76-18.76 9-31.01 11.87-50.91 11.87-31.2 0-57.61-11.1-79.82-33.5-22.4-22.2-33.5-48.62-33.5-79.05 0-20.86 2.68-32.73 11.87-51.87 13.78-28.9 40.58-50.91 72.73-59.53 19.72-5.36 46.9-4.4 66.42 2.49zm283.29-3.44c30.43 7.27 62.21 32.73 75.22 60.29 9.19 19.14 12.06 31.96 11.87 52.64-.38 47.08-29.09 87.66-75.03 105.85-11.48 4.4-15.5 4.98-37.71 5.17-21.25 0-26.8-.57-37.71-4.4-33.69-11.68-62.02-41.15-72.92-75.99-6.13-19.71-5.55-48.43 1.15-67.57 6.89-19.91 15.5-33.3 30.63-47.47 14.17-13.4 33.5-24.31 50.72-28.33 14.54-3.64 38.84-3.64 53.78-.19zm295.91.95c31.96 8.23 59.53 30.43 73.31 59.72 9 18.76 11.87 31.01 11.87 50.91 0 31.2-11.1 57.42-33.5 79.82s-48.62 33.5-79.82 33.5c-19.91 0-32.16-2.87-50.91-11.87-61.63-29.29-82.5-108.72-43.45-166.14 26.99-39.81 75.41-58 122.5-45.94z"
                fill="#007dff"
            />
            <path
                d="M181.88 715.14c-22.78 7.27-38.85 21.44-49.96 44.21-5.74 11.67-6.13 13.59-6.13 33.5 0 19.71.38 21.82 6.13 34.07 13.02 27.18 39.05 45.17 67.95 46.89 75.8 4.4 116.95-84.79 63.55-138.2-21.44-21.43-53.4-29.47-81.54-20.47z"
                fill="#ffa600"
            />
            <path
                d="M480.09 713.61C468.22 716.48 451 726.63 442 736.2c-12.06 12.82-18.38 24.88-21.63 41.15-5.36 25.84 1.72 51.1 19.72 70.24 16.65 17.99 36.18 26.61 59.91 26.61 49.77 0 89-45.94 80.39-93.98-8.61-47.28-53.98-77.52-100.3-66.61z"
                fill="#e82c9a"
            />
            <path
                d="M771.8 714.57c-27.37 7.28-49.19 29.48-56.27 57.23-10.53 40.2 8.81 79.24 48.04 97.04 7.66 3.45 12.83 4.21 30.24 4.21 19.91.19 21.82-.19 34.07-5.93 17.04-8.04 32.16-23.16 40.2-40.2 5.74-12.25 6.13-14.16 5.93-34.07 0-17.42-.77-22.59-4.21-30.24-17.8-39.43-57.62-58.95-98-48.04z"
                fill="#18da70"
            />
        </g>
    </svg>
);

const signup = props => (
    <svg viewBox="0 0 417.118 417.118" {...props}>
        <path
            d="M176.505 0c46.66 0 84.49 37.82 84.49 84.48 0 46.67-37.83 110.49-84.49 110.49s-84.49-63.82-84.49-110.49c0-46.66 37.83-84.48 84.49-84.48z"
            fill="#fcd09f"
        />
        <circle cx={303.365} cy={327.118} r={90} fill="#ef806f" />
        <path fill="#fff" d="M241.14 319.618h124.451v15H241.14z" />
        <path fill="#fff" d="M295.865 264.893h15v124.451h-15z" />
        <path
            d="M199.363 327.118c0 21.69 6.67 41.85 18.09 58.54a228.305 228.305 0 01-40.95 3.68c-58.79 0-112.38-22.3-152.75-58.91v-.13c0-60.89 35.63-113.45 87.17-137.98 19.37 19.32 42.05 29.73 65.58 29.73 23.54 0 46.21-10.41 65.59-29.73a152.878 152.878 0 0144.54 32.15c-49.42 8.02-87.27 51-87.27 102.65z"
            fill="#1ea6c6"
        />
    </svg>
);

const section = props => (
    <svg height={512} viewBox="0 0 192 192" width={512} {...props}>
        <path
            d="M178.4 188.8H13.6c-5.744 0-10.4-4.656-10.4-10.4v-140h185.6v140c0 5.744-4.656 10.4-10.4 10.4z"
            fill="#e7eced"
        />
        <path
            d="M188.8 41.6H3.2v-28c0-5.744 4.656-10.4 10.4-10.4h164.8c5.744 0 10.4 4.656 10.4 10.4z"
            fill="#556080"
        />
        <path d="M16 16h12.8v12.8H16z" fill="#dd352e" />
        <path d="M41.6 16h12.8v12.8H41.6z" fill="#ebba16" />
        <path d="M67.2 16H80v12.8H67.2z" fill="#23a24d" />
        <path d="M19.2 124.8h153.6v48H19.2z" fill="#ebba16" />
        <g fill="#4d007e">
            <path d="M177.6 192H14.4C6.461 192 0 185.539 0 177.6V14.4C0 6.461 6.461 0 14.4 0h163.2c7.939 0 14.4 6.461 14.4 14.4v163.2c0 7.939-6.461 14.4-14.4 14.4zM14.4 6.4c-4.41 0-8 3.587-8 8v163.2c0 4.413 3.59 8 8 8h163.2c4.413 0 8-3.587 8-8V14.4c0-4.413-3.59-8-8-8z" />
            <path d="M28.8 32H16a3.2 3.2 0 01-3.2-3.2V16a3.2 3.2 0 013.2-3.2h12.8A3.2 3.2 0 0132 16v12.8a3.2 3.2 0 01-3.2 3.2zm-9.6-6.4h6.4v-6.4h-6.4zM54.4 32H41.6a3.2 3.2 0 01-3.2-3.2V16a3.2 3.2 0 013.2-3.2h12.8a3.2 3.2 0 013.2 3.2v12.8a3.2 3.2 0 01-3.2 3.2zm-9.6-6.4h6.4v-6.4h-6.4zM80 32H67.2a3.2 3.2 0 01-3.2-3.2V16a3.2 3.2 0 013.2-3.2H80a3.2 3.2 0 013.2 3.2v12.8A3.2 3.2 0 0180 32zm-9.6-6.4h6.4v-6.4h-6.4z" />
            <path d="M188.8 44.8H3.2A3.2 3.2 0 010 41.6V14.4C0 6.461 6.461 0 14.4 0h163.2c7.939 0 14.4 6.461 14.4 14.4v27.2a3.2 3.2 0 01-3.2 3.2zM6.4 38.4h179.2v-24c0-4.413-3.59-8-8-8H14.4c-4.41 0-8 3.587-8 8zM24 112h-4.8a3.2 3.2 0 01-3.2-3.2V104a3.2 3.2 0 116.4 0v1.6H24a3.2 3.2 0 110 6.4zM19.2 92.07a3.2 3.2 0 01-3.2-3.2V77.523a3.2 3.2 0 116.4 0V88.87a3.2 3.2 0 01-3.2 3.2zM19.2 65.6a3.2 3.2 0 01-3.2-3.2v-4.8a3.2 3.2 0 013.2-3.2H24a3.2 3.2 0 110 6.4h-1.6v1.6a3.2 3.2 0 01-3.2 3.2zM155.478 60.8h-9.392a3.2 3.2 0 110-6.4h9.392a3.2 3.2 0 110 6.4zm-21.913 0h-9.392a3.2 3.2 0 110-6.4h9.392c1.766 0 3.2 1.43 3.2 3.2s-1.431 3.2-3.2 3.2zm-21.914 0h-9.392a3.2 3.2 0 110-6.4h9.392a3.2 3.2 0 110 6.4zm-21.913 0h-9.392a3.2 3.2 0 110-6.4h9.392c1.766 0 3.2 1.43 3.2 3.2s-1.431 3.2-3.2 3.2zm-21.911 0h-9.392a3.2 3.2 0 110-6.4h9.392a3.2 3.2 0 110 6.4zm-21.913 0h-9.392a3.2 3.2 0 110-6.4h9.392a3.2 3.2 0 110 6.4zM172.8 65.6a3.2 3.2 0 01-3.2-3.2v-1.6H168a3.2 3.2 0 110-6.4h4.8a3.2 3.2 0 013.2 3.2v4.8a3.2 3.2 0 01-3.2 3.2zM172.8 92.074a3.2 3.2 0 01-3.2-3.2V77.526a3.2 3.2 0 116.4 0v11.347a3.2 3.2 0 01-3.2 3.201zM172.8 112H168a3.2 3.2 0 110-6.4h1.6V104a3.2 3.2 0 116.4 0v4.8a3.2 3.2 0 01-3.2 3.2zM155.478 112h-9.392a3.2 3.2 0 110-6.4h9.392a3.2 3.2 0 110 6.4zm-21.913 0h-9.392a3.2 3.2 0 110-6.4h9.392c1.766 0 3.2 1.43 3.2 3.2s-1.431 3.2-3.2 3.2zm-21.914 0h-9.392a3.2 3.2 0 110-6.4h9.392a3.2 3.2 0 110 6.4zm-21.913 0h-9.392a3.2 3.2 0 110-6.4h9.392c1.766 0 3.2 1.43 3.2 3.2s-1.431 3.2-3.2 3.2zm-21.911 0h-9.392a3.2 3.2 0 110-6.4h9.392a3.2 3.2 0 110 6.4zm-21.913 0h-9.392a3.2 3.2 0 110-6.4h9.392a3.2 3.2 0 110 6.4zM96 96a3.2 3.2 0 01-3.2-3.2V73.6a3.2 3.2 0 116.4 0v19.2A3.2 3.2 0 0196 96z" />
            <path d="M105.6 86.4H86.4a3.2 3.2 0 110-6.4h19.2a3.2 3.2 0 110 6.4zM172.8 176H19.2a3.2 3.2 0 01-3.2-3.2v-48a3.2 3.2 0 013.2-3.2h153.6a3.2 3.2 0 013.2 3.2v48a3.2 3.2 0 01-3.2 3.2zm-150.4-6.4h147.2V128H22.4z" />
        </g>
    </svg>
);
const login = props => (
    <svg height={512} viewBox="0 0 468 468" width={512} {...props}>
        <path
            d="M312.591 344.677H127.409c-6.119 0-11.08-4.96-11.08-11.079V200.293a11.08 11.08 0 017.678-10.544l45.857-14.792a11.08 11.08 0 0113.526 6.044L220 263.37l36.609-82.368a11.08 11.08 0 0113.526-6.044l45.857 14.792a11.08 11.08 0 017.678 10.544v133.304c0 6.119-4.96 11.079-11.079 11.079z"
            fill="#fff"
        />
        <path
            d="M154.626 212.95l37.075-13.249-8.311-18.699a11.08 11.08 0 00-13.526-6.044l-45.857 14.792a11.08 11.08 0 00-7.678 10.544v133.304c0 6.119 4.96 11.079 11.08 11.079h17.92V226.162a14.028 14.028 0 019.297-13.212z"
            fill="#e6e7e8"
        />
        <ellipse cx={220} cy={71.127} fill="#0795fe" rx={66} ry={66.127} />
        <path
            d="M206.297 269.484l-35.176-79.143-39.792 12.836v21.486h-30v-24.369c0-11.376 7.268-21.362 18.084-24.85l45.854-14.791c12.708-4.103 26.395 2.016 31.825 14.235L220 226.425l22.906-51.537c5.431-12.219 19.115-18.339 31.827-14.236l45.855 14.792c10.814 3.487 18.082 13.473 18.082 24.849v20.654h-30v-17.77l-39.792-12.836-35.176 79.143c-4.702 11.041-21.702 12.795-27.405 0zM101.329 248.708h30v26.529h-30z"
            fill="#3e4d6c"
        />
        <g>
            <path
                d="M265.425 309.396l-84.916-.068-32.036 20.122-31.448-20.146-32.036 20.122-29.867-20.145L15 348.722l40.52 39.486 206.349.113c15.2 35.444 54.062 59.627 94.383 59.649 53.761.029 97.022-44.242 96.746-99.008s-43.983-99.084-97.744-99.114c-40.321-.022-74.986 24.12-89.829 59.548z"
                fill="#fff"
            />
            <path
                d="M368.253 416.91c-36.445-.02-71.697-19.778-89.362-49.749-3.607-6.12-10.142-9.903-17.235-9.906l-194.136-.107-30.679-29.896L15 348.722l40.52 39.485 206.349.113c15.2 35.444 54.062 59.626 94.383 59.648 46.801.025 85.638-33.523 94.729-78.339-16.942 28.392-47.59 47.3-82.728 47.281z"
                fill="#e6e7e8"
            />
            <ellipse cx={356.197} cy={348.91} fill="#0795fe" rx={21} ry={21.383} />
            <path
                d="M356.291 463c-41.688 0-83.468-22.755-103.792-59.653l-197.042-.108a14.988 14.988 0 01-10.452-4.255L4.479 359.498c-5.953-5.801-5.976-15.674-.047-21.501l40.128-39.442a14.981 14.981 0 0118.884-1.74l21.783 14.691 23.782-14.934a14.974 14.974 0 0116.049.071l23.449 15.02 23.992-15.068a14.981 14.981 0 017.969-2.295h.012l75.445.061c19.323-36.48 57.254-59.541 99.26-59.541h.061c61.854.035 112.434 51.206 112.751 114.067.311 61.511-49.791 114.111-111.706 114.113zM61.56 373.184l200.289.11a14.999 14.999 0 0113.775 9.096c12.76 29.745 45.912 50.533 80.622 50.553 45.511 0 81.975-38.801 81.748-83.903-.233-46.381-37.361-84.136-82.764-84.161h-.045c-33.33 0-63.14 19.754-75.956 50.337a15.003 15.003 0 01-13.833 9.212h-.012l-80.608-.065-28.38 17.823a14.984 14.984 0 01-16.05-.071l-23.449-15.02-23.993 15.067a14.979 14.979 0 01-16.346-.266l-19.719-13.3-20.432 20.082z"
                fill="#3e4d6c"
            />
        </g>
    </svg>
);


const wpdmLogo = props => (
    <svg style={{width: '18px', height: '18px', marginLeft: '8px'}} viewBox="0 0 327.3 327.3" {...props}>
        <defs>
            <linearGradient
                id="prefix__linear-gradient"
                x1={11.99}
                y1={216.58}
                x2={263.62}
                y2={129.92}
                gradientUnits="userSpaceOnUse"
            >
                <stop offset={0} stopColor="#3c80e4" />
                <stop offset={1} stopColor="#229df0" />
            </linearGradient>
            <style />
        </defs>
        <title>{'wpdm logo v5'}</title>
        <g id="prefix__Layer_2" data-name="Layer 2">
            <g id="prefix__download-manager-logo">
                <g id="prefix__wpdm_logo_v3" data-name="wpdm logo v3">
                    <path
                        id="prefix__arrow"
                        d="M149.87 180.29l-91.41-91A20 20 0 0158.39 61L64 55.36a20 20 0 0128.29-.07l71.52 71.18 71-71.7a20 20 0 0128.29-.13l5.68 5.62a20 20 0 01.14 28.29l-90.75 91.64a20 20 0 01-28.3.1z"
                        fill="#3c80e4"
                    />
                    <path
                        id="prefix__circle"
                        d="M186.66 202.9a32 32 0 01-45.29.16l-43.79-43.58a78 78 0 10132.49-.41z"
                        fill="#094168"
                    />
                </g>
            </g>
        </g>
    </svg>
);

const posts = props => (
    <svg height="512pt" viewBox="0 0 512 512" width="512pt" {...props}>
        <path d="M512 120v392H0V120l39.3-30h433.4zm0 0" fill="#f2f2fc" />
        <path d="M512 120v392H256V90h216.7zm0 0" fill="#d8d8fc" />
        <path d="M271 181h196v30H271zm0 0M271 241h196v30H271zm0 0" fill="#a3a3d1" />
        <path
            d="M45 301h422v30H45zm0 0M45 361h196v30H45zm0 0M45 421h196v30H45zm0 0"
            fill="#d8d8fc"
        />
        <path
            d="M467 451H271v-90h196zm0 0M256 301h211v30H256zm0 0"
            fill="#a3a3d1"
        />
        <path d="M45 181v90h196v-90zm0 0" fill="#d8d8fc" />
        <path d="M512 0H361l-30 69.375L361 120h151zm0 0" fill="#47568c" />
        <path d="M0 0h361v120H0zm0 0" fill="#4bb9ec" />
        <path d="M256 0h105v120H256zm0 0" fill="#0095ff" />
        <g fill="#f2f2fc">
            <path d="M60 45h30v30H60zm0 0M121 45h30v30h-30zm0 0M181 45h30v30h-30zm0 0" />
        </g>
    </svg>
);
const dashboard = props => (
    <svg height={512} viewBox="0 0 512 512" width={512} {...props}>
        <path d="M328.2 447.99H183.8l10-57.79h124.4z" fill="#aac2cc" />
        <path d="M328.2 447.99h-29.32l-10-57.79h29.32z" fill="#86a0a8" />
        <path
            d="M348.203 447.991H163.798c-8.284 0-15 6.716-15 15s6.716 15 15 15h184.406c8.284 0 15-6.716 15-15s-6.716-15-15.001-15z"
            fill="#c2e8ef"
        />
        <path
            d="M363.203 462.991c0 8.28-6.72 15-15 15h-30c8.28 0 15-6.72 15-15 0-8.29-6.72-15-15-15h30c8.28 0 15 6.711 15 15z"
            fill="#9dcfd6"
        />
        <path
            d="M504.5 57.72v308.76c0 13.1-10.62 23.72-23.71 23.72H31.21c-12.17 0-22.21-9.18-23.55-21a22.2 22.2 0 01-.16-2.72V57.72c0-13.09 10.62-23.71 23.71-23.71h449.58c13.09 0 23.71 10.62 23.71 23.71z"
            fill="#e1f9ff"
        />
        <path
            d="M504.5 57.72v308.76c0 13.1-10.62 23.72-23.71 23.72H31.21c-12.17 0-22.21-9.18-23.55-21h448.12c13.1 0 23.72-10.62 23.72-23.72V57.72c0-13.09-10.62-23.71-23.71-23.71h25c13.09 0 23.71 10.62 23.71 23.71z"
            fill="#c2e8ef"
        />
        <path
            d="M504.5 350.2v16.28c0 13.1-10.62 23.72-23.71 23.72H31.21c-12.17 0-22.21-9.18-23.55-21a22.2 22.2 0 01-.16-2.72V350.2z"
            fill="#4a555b"
        />
        <path
            d="M504.5 350.2v16.28c0 13.1-10.62 23.72-23.71 23.72H31.21c-12.17 0-22.21-9.18-23.55-21h448.12c11.48 0 21.06-8.16 23.25-19z"
            fill="#2d383d"
        />
        <path d="M317.281 186.559h-38.919v-78.954h38.919z" fill="#ffd85c" />
        <path d="M388.891 186.559h-38.919V129.06h38.919z" fill="#ff6248" />
        <path d="M459.971 186.559h-38.919V87.81h38.919z" fill="#2cdddd" />
        <g>
            <path d="M480.787 26.509h-96.481a7.5 7.5 0 000 15h96.481c8.94 0 16.213 7.273 16.213 16.213v284.974H15V57.722c0-8.94 7.273-16.213 16.213-16.213h318.092a7.5 7.5 0 000-15H31.213C14.002 26.509 0 40.511 0 57.722v308.761c0 17.211 14.002 31.213 31.213 31.213h71.801a7.5 7.5 0 000-15H31.213c-8.94 0-16.213-7.273-16.213-16.213v-8.787h482v8.787c0 8.94-7.273 16.213-16.213 16.213H137.684a7.5 7.5 0 000 15h47.204l-7.405 42.795h-13.686c-12.407 0-22.5 10.093-22.5 22.5s10.093 22.5 22.5 22.5h184.406c12.407 0 22.5-10.093 22.5-22.5s-10.093-22.5-22.5-22.5h-13.686l-7.405-42.795h153.674c17.211 0 31.213-14.002 31.213-31.213V57.722c.001-17.211-14.001-31.213-31.212-31.213zM319.294 440.491h-20.418a7.5 7.5 0 000 15h49.327c4.136 0 7.5 3.364 7.5 7.5s-3.364 7.5-7.5 7.5H163.797c-4.136 0-7.5-3.364-7.5-7.5s3.364-7.5 7.5-7.5h100.067a7.5 7.5 0 000-15h-71.158l7.405-42.795H311.89z" />
            <path d="M405.719 216.277a7.501 7.501 0 00-6.685 4.099l-35.394 69.565-29.868-58.705a7.501 7.501 0 00-13.37 0l-16.191 31.822H278.36a7.5 7.5 0 000 15h30.45a7.501 7.501 0 006.685-4.099l11.592-22.783 29.868 58.705a7.501 7.501 0 0013.37 0l35.394-69.565 17.117 33.644a7.501 7.501 0 006.685 4.099h30.45a7.5 7.5 0 000-15H434.12l-21.716-42.683a7.501 7.501 0 00-6.685-4.099zM278.363 194.059h38.919a7.5 7.5 0 007.5-7.5v-78.954a7.5 7.5 0 00-7.5-7.5h-38.919a7.5 7.5 0 00-7.5 7.5v78.954a7.5 7.5 0 007.5 7.5zm7.5-78.954h23.919v63.954h-23.919zM388.891 121.56h-38.919a7.5 7.5 0 00-7.5 7.5v57.499a7.5 7.5 0 007.5 7.5h38.919a7.5 7.5 0 007.5-7.5V129.06a7.5 7.5 0 00-7.5-7.5zm-7.5 57.499h-23.919V136.56h23.919zM459.971 194.059a7.5 7.5 0 007.5-7.5V87.81a7.5 7.5 0 00-7.5-7.5h-38.919a7.5 7.5 0 00-7.5 7.5v98.749a7.5 7.5 0 007.5 7.5zM428.552 95.31h23.919v83.749h-23.919zM221.898 165.152h-170a7.5 7.5 0 000 15h170a7.5 7.5 0 000-15zM51.898 219.993H82.32a7.5 7.5 0 000-15H51.898a7.5 7.5 0 000 15zM221.898 204.993H116.685a7.5 7.5 0 000 15h105.213a7.5 7.5 0 000-15zM221.898 80.31h-170a7.5 7.5 0 000 15h170a7.5 7.5 0 000-15zM51.898 135.152H157.32a7.5 7.5 0 000-15H51.898a7.5 7.5 0 000 15zM221.898 120.152h-30.213a7.5 7.5 0 000 15h30.213a7.5 7.5 0 000-15zM229.398 251.851a7.5 7.5 0 00-7.5-7.5h-170a7.5 7.5 0 000 15h170a7.5 7.5 0 007.5-7.5zM51.898 283.981a7.5 7.5 0 000 15h80a7.5 7.5 0 000-15z" />
        </g>
    </svg>
);

const search = props => (
    <svg height={512} viewBox="0 0 512 512" width={512} {...props}>
        <path
            d="M30.2 242.6c0 38 30.9 69 69 69H124c6-61.8 58.1-110.2 121.4-110.2s115.5 48.5 121.4 110.2h45.9c38 0 69-30.9 69-69s-30.9-69-69-69c-7.2 0-14.4 1.2-21.3 3.4-10.9 2.9-18.8-5.5-18.5-13.7 1.2-77.3-60-132.7-129.8-133-37.4-1.1-74.8 17.5-99.7 47.6h30.1c7.8 0 14.1 6.3 14.1 14.1s-6.3 14.1-14.1 14.1h-48.1c-3.7 7.9-6.7 16.3-8.7 25.1h24.9c7.8 0 14.1 6.3 14.1 14.1s-6.3 14.1-14.1 14.1h-28.3v.1c0 7.8-6.3 14-14.1 14-38 .1-69 31.1-69 69.1z"
            fill="#fff"
        />
        <path
            d="M353.3 283.4h59.5c22.5 0 40.8-18.3 40.8-40.8s-18.3-40.8-40.8-40.8c-4.2 0-8.5.7-12.6 2l-56.8 18.5 1.4-59.7c.7-28.1-9.9-54.5-29.6-74.3-19.2-19.2-44.7-29.8-71.9-29.8s-52.7 10.6-71.9 29.8c-19.1 19.1-29.6 44.4-29.7 71.4l-.2 42.1H99.2c-22.5 0-40.8 18.3-40.8 40.8s18.3 40.8 40.8 40.8h38.4"
            fill="#56ace0"
        />
        <path
            d="M339.3 323.4c0-51.7-42.1-93.8-93.8-93.8s-93.8 42.1-93.8 93.8 42.1 93.8 93.8 93.8 93.8-42.1 93.8-93.8zM245.5 389c-17.5 0-34-6.8-46.4-19.2-25.6-25.6-25.6-67.2 0-92.8 12.4-12.4 28.9-19.2 46.4-19.2s34 6.8 46.4 19.2c25.6 25.6 25.6 67.2 0 92.8-12.4 12.4-28.9 19.2-46.4 19.2z"
            fill="#fff"
        />
        <path
            d="M340.1 400.3c-5.3 6.5-11.2 12.4-17.7 17.7l60.2 60.2c4.9 4.9 12.9 4.9 17.7 0 4.9-4.9 4.9-12.9 0-17.7z"
            fill="#ffc10d"
        />
        <path
            d="M412.8 339.8c53.6 0 97.2-43.6 97.2-97.2s-43.6-97.2-97.2-97.2c-4.1 0-8.1.3-12.2.8-7.3-84.7-78.7-144-157.4-144.1-85.4.7-151.7 67.8-157.5 144.2C38.5 152.9 2 193.6 2 242.6c0 53.6 43.6 97.2 97.2 97.2h25.5c8.1 59.6 59.1 105.6 120.8 105.6 18.8 0 36.5-4.4 52.4-12l64.7 64.7c13.2 13.4 39.4 17.7 57.7 0 15.9-15.9 15.9-41.8 0-57.7l-64.7-64.7c5.3-11.2 9-23.3 10.8-36h46.4zM30.2 242.6c0-38 30.9-69 69-69 7.8 0 14.1-6.3 14.1-14v-.1h28.3c7.8 0 14.1-6.3 14.1-14.1s-6.3-14.1-14.1-14.1h-24.9c2.1-8.8 5-17.1 8.7-25.1h48.1c7.8 0 14.1-6.3 14.1-14.1S181.3 78 173.5 78h-30.1c25-30.1 62.3-48.7 99.7-47.6 69.8.2 131 55.7 129.8 133-.4 8.2 7.5 16.7 18.5 13.7 7-2.3 14.1-3.4 21.3-3.4 38 0 69 30.9 69 69s-30.9 69-69 69h-45.9c-6-61.8-58.1-110.2-121.4-110.2S130 249.8 124 311.6H99.2c-38 0-69-31-69-69zm121.4 80.8c0-51.7 42.1-93.8 93.8-93.8s93.8 42.1 93.8 93.8-42.1 93.8-93.8 93.8-93.8-42.1-93.8-93.8zm248.7 137.1c4.9 4.9 4.9 12.9 0 17.7-4.9 4.9-12.9 4.9-17.7 0L322.4 418c6.5-5.3 12.4-11.2 17.7-17.7z"
            fill="#194f82"
        />
        <circle cx={245.5} cy={323.4} fill="#ffc10d" r={66.2} />
    </svg>
);


const email_download = props => (
    <svg height={512} viewBox="0 0 468 468" width={512} {...props}>
        <path d="M47 190.997h374v262.019H47z" fill="#fff" />
        <path
            d="M87 191H47v262h374v-40H309c-122.607 0-222-99.393-222-222z"
            fill="#e6e7e8"
        />
        <path
            d="M234 22.985L47 190.643l186.855 168.443L421 190.643z"
            fill="#fff"
        />
        <path
            d="M284.392 15.128l-169.334-.112-.5 236.523 119.297 107.547L355 249.867V85.87z"
            fill="#fff"
        />
        <path d="M355 85.87h-70.258V15.009z" fill="#fff" />
        <g>
            <path d="M182 233.001h115v30H182z" fill="#0795fe" />
        </g>
        <path
            d="M435.514 194c1.131-5.136-.357-10.809-4.5-14.525L370 124.771V86h-.009c-.001-4-1.499-7.761-4.34-10.626L295.174 4.48C293.392 2.683 292 1.491 289 .822V.099L115.068 0h-.011c-8.271 0-14.982 6.704-15 14.976l-.229 108.156-62.843 56.343a15.002 15.002 0 00-4.986 11.148L32 453c0 8.284 6.716 15 15 15h374c8.284 0 15-6.716 15-15V194zM370 165.064l28.535 25.584L370 216.253zM300 51.442L319.004 71H300zM130.119 30.027l139.881.07V85.87c0 8.284 6.457 15.13 14.741 15.13H340v142.194L233.855 338.89l-104.189-94.01zM99.744 163.5l-.115 54.386-30.192-27.214zM406 438H62V224.358l161.811 145.868c5.618 5.065 14.469 5.066 20.088 0L406 224.324z"
            fill="#3e4d6c"
        />
        <path
            d="M258.778 141.063l-9.855 12.193V79h-30v75.767l-10.144-11.972-22.889 19.394 36.588 43.345c6.158 7.268 17.144 7.115 23.11-.267l36.521-45.264z"
            fill="#0795fe"
        />
    </svg>
);


const table = props => (
    <svg height={512} viewBox="0 0 468 468" width={512} {...props}>
        <path
            d="M47 101.813V439c0 7.732 6.268 14 14 14h346c7.732 0 14-6.268 14-14V101.813z"
            fill="#fff"
        />
        <path
            d="M97 101.814H47V439c0 7.732 6.268 14 14 14h346c7.732 0 14-6.268 14-14v-36l-33.392-3.295C231.197 384.269 108.56 258.559 97 101.814z"
            fill="#e6e7e8"
        />
        <path
            d="M421 29c0-7.732-6.268-14-14-14H61c-7.732 0-14 6.268-14 14v72.813h374z"
            fill="#fff"
        />
        <path
            d="M407 0H61C45.009 0 32 13.009 32 29v410c0 15.991 13.009 29 29 29h346c15.991 0 29-13.009 29-29V29c0-15.991-13.009-29-29-29zm-1 86.813h-92.517V30H406zm-221.483 0V30h98.966v56.813zm98.966 30V438h-98.966V116.813zM62 30h92.517v56.813H62zm0 86.813h92.517V438H62zM406 438h-92.517V116.813H406z"
            fill="#3e4d6c"
        />
        <path
            d="M205.115 158.373h57.77v30h-57.77zM205.115 228.373h57.77v30h-57.77zM205.115 298.373h57.77v30h-57.77z"
            fill="#0795fe"
        />
        <g>
            <path
                d="M78.914 158.373h57.769v30H78.914zM78.914 228.373h57.769v30H78.914zM78.914 368.373h57.769v30H78.914z"
                fill="#3e4d6c"
            />
        </g>
        <g>
            <path
                d="M331.317 158.373h57.769v30h-57.769zM331.317 298.373h57.769v30h-57.769zM331.317 368.373h57.769v30h-57.769z"
                fill="#3e4d6c"
            />
        </g>
        <g>
            <path d="M215.982 44.888h36.035v30h-36.035z" fill="#3e4d6c" />
        </g>
        <g>
            <path d="M89.78 44.888h36.036v30H89.78z" fill="#0795fe" />
        </g>
        <g>
            <path d="M342.184 44.888h36.036v30h-36.036z" fill="#0795fe" />
        </g>
    </svg>
);


( function() {
    wp.blocks.updateCategory( 'wpdm-blocks', { icon: wpdmLogo } );
} )();

const wpdmIcons = {downloadIcon, section, catIcon, signup, slider, packages, theCat, btnC2A, login, search, dashboard, table};

export default wpdmIcons;

